import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { appVersionDataProvider, RESOURCE } from './dataProvider';

export function initAppVersionDataProvider() {
  registerModuleDataProvider(RESOURCE, appVersionDataProvider);
}

initAppVersionDataProvider();
